/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { POOL_STATE_SERVICE_TOKEN } from '../../../../downgrade-services.tokens';
import './pool-detail.component.less';

/**
 * @ngdoc component
 * @name poolDetail
 * @description
 *     Pool detail page component containing the Pool child pages.
 * @param {Pool} resolvePool - The resolved pool instance
 * @param {VirtualService} resolveVS - The resolved virtual service instance
 */
class PoolDetailController {
    constructor(
        $scope,
        $state,
        myAccount,
        poolStateService,
    ) {
        $scope.$state = $state;
        $scope.myAccount = myAccount;
        $scope.poolStateService = poolStateService;

        this.$scope_ = $scope;
    }

    $onInit() {
        const pool = this.resolvePool;
        const vs = this.resolveVS;

        pool.vs_ = vs;
        pool.vsId_ = vs.id;

        this.$scope_.pool = pool;

        /** @deprecated
         * This is kept for backward compatibility with the old code for Alerts, Events and Servers tabs.
         */
        this.$scope_.Pool = pool;

        this.$scope_.vs = vs;

        // Set pool state service for cross-module sharing
        this.$scope_.poolStateService.pool = pool;
        this.$scope_.poolStateService.initialVs = vs;
    }

    $onDestroy() {
        this.$scope_.vs.destroy();
        this.$scope_.pool.destroy();
    }
}

PoolDetailController.$inject = [
    '$scope',
    '$state',
    'myAccount',
    POOL_STATE_SERVICE_TOKEN,
];

angular.module('aviApp').component('poolDetail', {
    bindings: {
        resolvePool: '<',
        resolveVS: '<',
    },
    controller: PoolDetailController,
    templateUrl: 'src/components/pages/item-detail/pool-detail/pool-detail.component.html',
});
